export const makeLink = (url: string, copy?: string) => {
  return (
    url?.startsWith('mailto:')
      ? `<a href="${url}" class="underline">${copy ?? url}</a>`
      : `<a href="${url}" target="new" class="underline">${copy ?? url}</a>`
  );
};
